/**
 * converts monthly revenue (number) to yearly revenue
 */
export const convertMonthlyToYearly = (monthlyValue: number): number => {
    return Math.round(monthlyValue * 12);
};
